import { stringSchema, objectSchema } from '@/schemas'

export const googleAdsSchema = objectSchema({
  customer_id: stringSchema
    .min(1, 'Customer ID must be at least 1 character')
    .max(100, 'Customer ID must be at most 100 characters'),
  manager_customer_id: stringSchema
    .min(1, 'Manager ID must be at least 1 character')
    .max(100, 'Manager ID must be at most 100 characters'),
  book_appointment_action_id: stringSchema.optional(),
  purchase_action_id: stringSchema.optional(),
  qualified_lead_action_id: stringSchema.optional(),
  disqualified_lead_action_id: stringSchema.optional(),
})

export const mailchimpSchema = objectSchema({
  list_id: stringSchema
    .min(1, 'List ID must be at least 1 character')
    .max(100, 'List ID must be at most 100 characters'),
})
